// extracted by mini-css-extract-plugin
module.exports = {"container":"burger_container__1e8jT","burger":"burger_burger__Jngm_","inner":"burger_inner__2NkRc","isActive":"burger_isActive__1ts10","box":"burger_box__1I7ap"};